export const getFontWeightStyle = (type) => {
  switch (type) {
    case 'thin':
      return '300';
    case 'regular':
      return '400';
    case 'medium':
      return '500';
    case 'semiBold': 
      return '600';
    case 'bold':
      return '700';
    default:
      return '400';
  }
}

const getFontSizeStyle = (type) => {
  const styles = {} as any;
  switch (type) {
    case 'extraSmall':
      styles.fontSize = '12px';
      styles.lineHeight = '1';
      break;
    case 'small':
      styles.fontSize = '13px';
      styles.lineHeight = '1';
      break;
    case 'regular':
      styles.fontSize = '14px';
      styles.lineHeight = '1';
      break;
    case 'medium':
      styles.fontSize = '16px';
      styles.lineHeight = '1.2';
      break;
    case 'large':
      styles.fontSize = '18px';
      styles.lineHeight = '1.2';
      break;
    case 'extraLarge':
      styles.fontSize = '20px';
      styles.lineHeight = '1.2';
      break;
    case 'displayRegular': 
      styles.fontSize = '28px';
      styles.lineHeight = '1.2';
      break;
    case 'displayMedium': 
      styles.fontSize = '36px';
      styles.lineHeight = '1.2'
      break;
    case 'displayLarge': 
      styles.fontSize = '48px';
      styles.lineHeight = '1.2'
      break;
    default:
      styles.fontSize = '16px';
      styles.lineHeight = '1.1';
      break;
  }
  return styles;
}
export const getFilterTitleStyle = (config, isMobile) => {
  const { desktop_configs, mobile_configs, title_color = '#000000', title_thickness = '400', title_case = 'none' } = config?.sortAndFilter || {};
  return {
    ...getFontSizeStyle(isMobile ? mobile_configs?.title_size || 'small' : desktop_configs?.title_size || 'small'),
    color: title_color,
    textTransform: title_case,
    fontWeight: getFontWeightStyle(title_thickness)
  }
}

export const getFilterOptionStyle = (config, isMobile) => {
  const { desktop_configs, mobile_configs, filter_options_color = '#000000', filter_options_thickness = '400', filter_options_case = 'none' } = config?.sortAndFilter || {};
  return {
    ...getFontSizeStyle(isMobile ? mobile_configs?.filter_options_size || 'small' : desktop_configs?.filter_options_size || 'small'),
    color: filter_options_color,
    textTransform: filter_options_case,
    fontWeight: getFontWeightStyle(filter_options_thickness)
  }
}

export const getHeadingStyle = (config, isMobile) => {
  const { text_size_desktop, text_size_mobile, text_color = '#000000', text_thickness = '400', text_case = 'none' } = config || {};
  return {
    fontSize: getFontSizeStyle(isMobile? text_size_mobile ||'regular' : text_size_desktop ||'regular').fontSize,
    color: text_color,
    textTransform: text_case,
    fontWeight: getFontWeightStyle(text_thickness)
  }
}
